import axios from "axios";
import store from "../store";

const axiosInstance = axios.create({
  baseURL: "",
  params: {},
  headers: {
    //Authorization: `Bearer ${store.state.token}`
  },
});

axiosInstance.interceptors.request.use((request) => {
  request.headers["Content-Language"] = store.state.language;
  request.params["customerID"] =
    store?.state?.customerID ??
    document.getElementById("customerid")?.value ??
    null;
  return request;
});

export {axiosInstance};
